export const providers = {
    creaticket: 'creaticket',
    vodafone: 'vodafone',
    redsys: 'redsys'
};
const subdomain = document.location.hostname.split('.').shift() || '';
export const provider = providers[subdomain] || 'creaticket';



//////////////////
// WEBPACK FOOTER
// ./src/helpers/Providers.ts
// module id = 89
// module chunks = 0